<script setup lang="ts">
import { ref, watch } from 'vue';
import { useDebounce } from '@vueuse/core';
import { CURRENCY } from '@Constants';
import type { FieldSchema } from '../../../types';

defineOptions({ inheritAttrs: false });

const props = withDefaults(
  defineProps<{
    currency?: CURRENCY;
    error?: string;
    field?: FieldSchema;
    placeholder?: string;
    required?: boolean;
  }>(),
  {
    currency: CURRENCY.USD,
    placeholder: 'components.forms.placeholder.common',
  }
);

const model = defineModel<number | string | null>({ required: true, default: null });

const _model = ref<number | null>(props.field?.model ? Number(props.field?.model) : null);
const debouncedModel = useDebounce(_model, 200);

watch(debouncedModel, (value) => (model.value = value));
</script>

<template>
  <InputNumber
    v-model="_model"
    mode="currency"
    :class="['h-9 w-full', { 'af-field-error': !!error }]"
    :currency="field?.settings.currency || currency"
    :invalid="!!error"
    :placeholder="$t(field?.settings.placeholder || placeholder)"
    :pt:input:root="['text-sm', { 'af-field-error': !!error }]"
    :required="field?.settings.required || required"
    @input="_model = Number($event.value)"
  />
</template>
